import React, { useContext, useState, useEffect, useRef } from "react";
import { BsArrowUpSquareFill } from "react-icons/bs";
import { MdPhoneIphone } from "react-icons/md";
import { CommonContext } from "../../hooks/CommonContext";

const isDisplayMediaSupported = !!navigator.mediaDevices?.getDisplayMedia;

const ScreenShareToggleButton = () => {
  const { shareScreen, stopSharedScreenHandler, isScreenSharedInMeeting } =
    useContext(CommonContext);

  const isSelf     = isScreenSharedInMeeting.isSelfShared;
  const isDisabled = !isSelf && isScreenSharedInMeeting.isShared;

  const [showToast, setShowToast] = useState(false);
  const timerRef = useRef(null);

  const triggerUnsupportedToast = () => {
    setShowToast(true);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setShowToast(false), 3500);
  };

  useEffect(() => () => clearTimeout(timerRef.current), []);

  const handleClick = () => {
    if (!isDisplayMediaSupported) {
      triggerUnsupportedToast();
      return;
    }
    if (isSelf) {
      stopSharedScreenHandler();
    } else if (!isScreenSharedInMeeting.isShared) {
      shareScreen();
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <button
        id="shareScreenBtn"
        title={isSelf ? "Stop sharing" : "Share screen"}
        disabled={isDisabled}
        className={`ftr-btn${isSelf ? " ftr-on" : ""}`}
        onClick={handleClick}
      >
        <BsArrowUpSquareFill />
      </button>

      {showToast && (
        <div style={{
          position: "absolute",
          bottom: "calc(100% + 12px)",
          left: "50%",
          transform: "translateX(-50%)",
          width: "220px",
          background: "#101827",
          border: "1px solid #1e2d4a",
          borderRadius: "12px",
          padding: "10px 12px",
          display: "flex",
          alignItems: "flex-start",
          gap: "10px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.5)",
          animation: "ftrToastIn 0.2s ease",
          zIndex: 300,
          pointerEvents: "none",
        }}>
          <span style={{
            flexShrink: 0,
            width: 28,
            height: 28,
            borderRadius: "50%",
            background: "rgba(239,68,68,0.15)",
            border: "1px solid rgba(239,68,68,0.3)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fca5a5",
            fontSize: 14,
          }}>
            <MdPhoneIphone />
          </span>
          <div>
            <div style={{ color: "#f0f4ff", fontSize: 12, fontWeight: 600, lineHeight: 1.3 }}>
              Not available on mobile
            </div>
            <div style={{ color: "#7a92c4", fontSize: 11, marginTop: 2, lineHeight: 1.4 }}>
              Screen sharing requires a desktop browser.
            </div>
          </div>
          <style>{`
            @keyframes ftrToastIn {
              from { opacity: 0; transform: translateX(-50%) translateY(6px); }
              to   { opacity: 1; transform: translateX(-50%) translateY(0); }
            }
          `}</style>
        </div>
      )}
    </div>
  );
};

export default ScreenShareToggleButton;
